export class WhatsAppChatModel {
	constructor() {
		this.chatDetail = [];
	}

	chatHeader: WhatsAppChatHeader;
	chatDetail: WhatsAppDetailModel[];
}

export class WhatsAppChatHeader {
	adminImage: string;
	customerImage: string;
	customerName: string;
	customerNo: string;
}

export class WhatsAppDetailModel {
	whatsAppMessage: string;
	whatsAppStatus: string
	createdDate: Date;
	seqNo: number;
}